// extracted by mini-css-extract-plugin
export default {"root":"UniversalLoader__root","loaderWrapper":"UniversalLoader__loaderWrapper"};